import { useState } from "react";
import { Scale } from "lucide-react";

export const BRAND_SYMBOL_URL = `${process.env.REACT_APP_BACKEND_URL}/api/branding/symbol`;

// RPLAW brand symbol. Falls back to a neutral icon only if the asset is unavailable.
export default function BrandMark({ className = "h-8 w-8", iconClassName = "h-8 w-8 text-amber-500" }) {
  const [err, setErr] = useState(false);
  if (err) return <Scale className={iconClassName} />;
  return (
    <img
      src={BRAND_SYMBOL_URL}
      onError={() => setErr(true)}
      alt="RPLAW"
      className={`${className} object-contain`}
      data-testid="brand-symbol"
    />
  );
}
